import { getStorege } from '../db_storage';

/* eslint-disable @typescript-eslint/no-explicit-any */
type Position = any;

interface IObj {
  lat: string;
  lng: string;
}

const geoLocationTimeout = (ms: number): Promise<never> =>
  new Promise<never>((resolve) =>
    setTimeout(() => {
      resolve(Promise.reject(console.info('timeout fishing')));
    }, ms),
  );

export const coordinates = async (): Promise<IObj> => {
  try {
    const dataLocation = getStorege('@mais/delivery/dataStateCity');

    if (
      dataLocation !== null &&
      typeof dataLocation === 'object' &&
      dataLocation.lat !== '' &&
      dataLocation.lng !== ''
    ) {
      return { lat: dataLocation.lat, lng: dataLocation.lng };
    }
    const locationPromise = new Promise<Position>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    const locationData = await Promise.race([
      locationPromise,
      geoLocationTimeout(3000),
    ]);
    const lat = String(locationData.coords.latitude);
    const lng = String(locationData.coords.longitude);

    return { lat, lng };
  } catch (error) {
    console.info(error);
    return { lat: '', lng: '' };
  }
};

export const coordinatesCurrent = async (): Promise<IObj> => {
  try {
    const locationPromise = new Promise<Position>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    const locationData = await Promise.race([
      locationPromise,
      geoLocationTimeout(3000),
    ]);
    const lat = String(locationData.coords.latitude);
    const lng = String(locationData.coords.longitude);

    return { lat, lng };
  } catch (error) {
    console.info(error);
    return { lat: '', lng: '' };
  }
};
